import { cn } from '../../lib/utils';

interface TypographyProps {
  children: React.ReactNode;
  className?: string;
}

export function H1({ children, className }: TypographyProps) {
  return (
    <h1 className={cn("font-kanit font-bold text-[48px] leading-[56px]", className)}>
      {children}
    </h1>
  );
}

export function H2({ children, className }: TypographyProps) {
  return (
    <h2 className={cn("font-kanit font-bold text-[36px] leading-[44px]", className)}>
      {children}
    </h2>
  );
}

export function H3({ children, className }: TypographyProps) {
  return (
    <h3 className={cn("font-kanit text-[22px] leading-[36px]", className)}>
      {children}
    </h3>
  );
}

export function H4({ children, className }: TypographyProps) {
  return (
    <h4 className={cn("font-inter font-medium text-[20px] leading-[32px]", className)}>
      {children}
    </h4>
  );
}

export function H5({ children, className }: TypographyProps) {
  return (
    <h5 className={cn("font-inter font-medium text-[18px] leading-[28px]", className)}>
      {children}
    </h5>
  );
}

export function BodyLarge({ children, className }: TypographyProps) {
  return (
    <p className={cn("font-inter font-medium text-[16px] leading-[28px]", className)}>
      {children}
    </p>
  );
}

export function Body({ children, className }: TypographyProps) {
  return (
    <p className={cn("font-inter font-medium text-[16px] leading-[24px]", className)}>
      {children}
    </p>
  );
}

export function BodySmall({ children, className }: TypographyProps) {
  return (
    <p className={cn("font-inter font-medium text-[14px] leading-[20px]", className)}>
      {children}
    </p>
  );
}